var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-4 pl-1" },
      [
        _c("ListCompanyUnits", {
          attrs: {
            label: "",
            name: "unitId",
            placeholder: "Unidad",
            "parent-value": _vm.serverConfig.divisionId,
            small: ""
          },
          on: { input: _vm.onServerChange },
          model: {
            value: _vm.serverConfig.unitId,
            callback: function($$v) {
              _vm.$set(_vm.serverConfig, "unitId", $$v)
            },
            expression: "serverConfig.unitId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4 pl-1" },
      [
        _c("ListUser", {
          attrs: {
            label: "",
            name: "targetUserId",
            small: "",
            placeholder: "Usuario"
          },
          on: { input: _vm.onServerChange },
          model: {
            value: _vm.serverConfig.targetUserId,
            callback: function($$v) {
              _vm.$set(_vm.serverConfig, "targetUserId", $$v)
            },
            expression: "serverConfig.targetUserId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4 pl-1" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "has-permission",
                rawName: "v-has-permission",
                value: "ED236",
                expression: "'ED236'"
              }
            ],
            attrs: { variant: "primary", size: "sm" },
            on: {
              click: function($event) {
                return _vm.clearFilterByUser()
              }
            }
          },
          [_vm._v(" Global ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }